import React, { useContext, useState, useEffect, Fragment } from 'react';
import { Button, Row, Select, Space, Divider } from 'antd';
import { useIntl } from 'react-intl';
import AddShiftModal from './addShiftModal';
import { fetchFieldsByUserId } from '../fields/api';
import { StoreContext } from '../store/index';
import { onCollectionChange } from '../utils';

const AddShift = ({ field }) => {
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;
  const { Option } = Select;

  const { formatMessage } = useIntl();
  const [showAddShiftModal, setShowAddShiftModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fieldsChanged, setFieldsChanged] = useState(false);
  const [selectedField, setSelectedField] = useState(null);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setSelectedField(field);
    onCollectionChange('fields', setFieldsChanged);
  }, [field]);

  useEffect(() => {
    fetchFieldsByUserId(user.uid, setLoading).then(p => setFields(p));
  }, [fieldsChanged]);

  return (
    <Fragment key="addShift">
      <Button
        style={{ marginTop: '4px', marginBottom: '4px' }}
        block
        type="primary"
        loading={loading}
        onClick={() => setShowAddShiftModal(true)}>
        {formatMessage({ id: 'shifts.actions.add' })}
      </Button>
      {user.isOwner && (
        <Select
          style={{ width: '100%' }}
          placeholder={formatMessage({ id: 'shifts.field.help' })}
          value={selectedField ? [selectedField.id] : []}
          onChange={value =>
            setSelectedField(fields.find(({ id }) => id === value))
          }>
          {fields.map(({ name, sport, id }) => (
            <Option key={id}>{`${sport} ${name}`}</Option>
          ))}
        </Select>
      )}
      {showAddShiftModal && (
        <AddShiftModal
          field={selectedField}
          visible={showAddShiftModal}
          onClose={() => setShowAddShiftModal(false)}
        />
      )}
    </Fragment>
  );
};

export default AddShift;
